<!doctype html>
<div id="wrapper-page">
  <main class="clearfix">
    <section class="home">
      <app-page-header [pageHeader]="pageHeader"></app-page-header>

      <app-top-articles></app-top-articles>

      <div class="separator">· · ·</div>

      <app-tour-list></app-tour-list>

      <div class="separator">· · ·</div>

      <app-section [section]="sectionConhecimentos"></app-section>

      <div class="separator">· · ·</div>

      <app-carousel></app-carousel>
    </section>
  </main>
</div>
